module.exports = __webpack_public_path__ + "3cafa6defc8270360b65822805a01c68.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.woff?67495670
// module id = 963
// module chunks = 0